import React from 'react'
// import warroom from "../../assets/video/04_EBC Glitch_FINAL.mp4"
import warroom from "../../assets/images/04_EBC Glitch_FINAL.gif"
import useFlickerEffect from '../../hooks/useFlickerEffect.ts';

const TheMission = () => {

    const activeClass = useFlickerEffect();

    return (
        <>
            <section id='EBC' className={`
            relative
            after:hidden after:xl:block
                after:absolute after:right-0 ${activeClass && 'after:animate-flicker'} after:top-[-250px] after:w-[500px] after:h-[1400px]  after:bg-[url('../src/assets/images/righteffeect2.png')] after:bg-no-repeat            
             z-30 px-5`}>
                <div className='max-w-[1440px] w-full mx-auto' >
                    <div className="   md:pb-[120px] pb-[60px]  " >
                        <h2 style={{ textShadow: "0px 0px 20px #2972D7" }} className='text-base md:text-[25px] lg:text-[35px]  xl:text-[40px] md:pb-[60px] pb-[30px] text-white text-center font-gothicproMedium md:leading-[52px]  drop-shadow-custom '>
                        // LA RESILENCIA CIBERNÉTICA SE ENCUENTRA <br /> CON LA ESTRATEGIA EJECUTIVA
                        </h2>
                        <div className='flex relative z-30 min-[1126px]:flex-row items-center gap-5 justify-between flex-col max-w-[1160px] mx-auto  w-full md:px-[15px]' >
                        {/* <video 
                                className='min-[1126px]:max-w-[694px] xl:max-h-[414px] w-full'
                                src={warroom}
                                autoPlay
                                loop
                                muted
                                playsInline
                            />                             */}
                            <img className='flex relative z-30 min-[1126px]:max-w-[694px] xl:max-h-[414px] w-full' src={warroom} alt="warroom" />
                            <div>
                                <div className='flex flex-col gap-5 md:gap-[42px]  min-[1126px]:max-w-[380px] w-full items-start' >
                                    <p className="text-[#C9C9C9] text-base md:text-[21px] font-inter leading-[140%] font-normal">
                                        El Armory War Room es un centro avanzado de ciberseguridad donde hackers éticos utilizan la plataforma de Armory para llevar a cabo simulaciones de
                                        <span className='text-[21px] font-bold font-inter text-white text-base md:text-[21px]' >  ataques reales <span>y</span> evaluaciones de vulnerabilidades. </span>
                                    </p>
                                    <p className="text-[#C9C9C9] text-base md:text-[21px] font-inter leading-[140%] font-normal">
                                        Los ejecutivos pueden experimentar escenarios de  <span className='text-[21px] font-bold font-inter text-white text-base md:text-[21px]' >ataques en vivo</span>   , recibir capacitación práctica en <span className='text-[21px] font-bold font-inter text-white text-base md:text-[21px]'> gestión de riesgos cibernéticos</span>   y comprender su propia
                                        <span className='text-[21px] font-bold font-inter text-white text-base md:text-[21px]' > exposición al riesgo digital </span> Este entorno inmersivo brinda a los líderes información estratégica accionable para fortalecer sus defensas y tomar decisiones de seguridad informadas en tiempo real.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TheMission
